import * as THREE from "three";
import App from "./App";
var Renderer = /** @class */ (function () {
    function Renderer() {
        this.app = new App();
        this.canvas = this.app.canvas;
        this.sizes = this.app.sizes;
        this.scene = this.app.scene;
        this.camera = this.app.camera;
        this.setInstance();
    }
    Renderer.prototype.setInstance = function () {
        this.instance = new THREE.WebGLRenderer({
            canvas: this.canvas,
            antialias: true,
        });
        this.instance.setClearColor(this.app.variables.backgroundColor);
        this.instance.setSize(this.sizes.width, this.sizes.height);
        this.instance.setPixelRatio(Math.min(this.sizes.pixelRatio, 2));
        this.instance.shadowMap.enabled = true;
        this.instance.shadowMap.type = THREE.PCFSoftShadowMap;
    };
    Renderer.prototype.resize = function () {
        this.instance.setSize(this.sizes.width, this.sizes.height);
        this.instance.setPixelRatio(Math.min(this.sizes.pixelRatio, 2));
    };
    Renderer.prototype.update = function () {
        this.instance.render(this.scene, this.camera.instance);
    };
    return Renderer;
}());
export default Renderer;
